import React, { useState, useRef } from 'react';
import Icon from '../AppIcon';


const NotificationsPanel = ({ isOpen, onClose, notifications = [], unreadCount = 0, onMarkAllRead, onMarkRead }) => {
  const [activeTab, setActiveTab] = useState('inbox');
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 200);
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-200 ${
          isClosing ? 'opacity-0' : 'opacity-100'
        }`}
        onClick={handleClose}
      />
      {/* Panel */}
      <div className={`fixed right-4 top-20 w-80 bg-white dark:bg-popover border border-gray-200 dark:border-border rounded-lg shadow-xl z-50 transition-all duration-200 ${
        isClosing ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'
      }`}>
        {/* Header */}
        <div className="p-4 border-b border-gray-200 dark:border-border flex items-center justify-between">
          <h3 className="font-semibold text-gray-900 dark:text-foreground">Bildirimler</h3>
          <button
            onClick={handleClose}
            className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-muted transition-colors"
          >
            <Icon name="X" size={16} className="text-gray-500 dark:text-muted-foreground" />
          </button>
        </div>

        {/* Tabs */}
        <div className="px-4 pt-2">
          <div className="flex">
            <button
              onClick={() => setActiveTab('inbox')}
              className={`flex-1 py-2 text-sm font-medium border-b-2 transition-colors ${
                activeTab === 'inbox' ?'text-blue-600 border-blue-600' :'text-gray-500 dark:text-muted-foreground border-transparent hover:text-gray-700 dark:hover:text-foreground'
              }`}
            >
              Gelen Kutusu
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="h-64 overflow-y-auto">
          {notifications?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full px-6 py-8">
              <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-4">
                <Icon name="Search" size={24} className="text-blue-600 dark:text-blue-400" />
              </div>
              <h4 className="font-medium text-gray-900 dark:text-foreground mb-2">Mesaj yok</h4>
              <p className="text-sm text-gray-500 dark:text-muted-foreground text-center leading-relaxed">
                Şu anda mesajınız yok. Bazı bildirimlerin görünmesi zaman alabilir. Lütfen daha sonra tekrar kontrol edin.
              </p>
            </div>
          ) : (
            <div className="p-2">
              {notifications?.map((notification) => (
                <div
                  key={notification?.id}
                  onClick={() => !notification?.read && onMarkRead?.(notification?.id)}
                  className={`p-3 rounded-md hover:bg-gray-50 dark:hover:bg-muted/50 cursor-pointer transition-colors mb-2 ${
                    !notification?.read ? 'bg-blue-50 dark:bg-blue-900/10' : ''
                  }`}
                >
                  <div className="flex items-start space-x-3">
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
                      notification?.type === 'trade' ? 'bg-green-100 text-green-600 dark:bg-green-900/20 dark:text-green-400' :
                      notification?.type === 'alert'? 'bg-orange-100 text-orange-600 dark:bg-orange-900/20 dark:text-orange-400' : 'bg-blue-100 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400'
                    }`}>
                      <Icon name={notification?.icon || 'Bell'} size={14} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-1">
                        <p className="font-medium text-gray-900 dark:text-foreground text-sm">{notification?.title}</p>
                        {!notification?.read && (
                          <div className="w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></div>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 dark:text-muted-foreground mb-1">{notification?.message}</p>
                      <p className="text-xs text-gray-500 dark:text-muted-foreground">
                        {notification?.timestamp ? new Date(notification?.timestamp)?.toLocaleString('tr-TR') : 'Az önce'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {notifications?.length > 0 && unreadCount > 0 && (
          <div className="p-3 border-t border-gray-200 dark:border-border">
            <button
              onClick={onMarkAllRead}
              className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-medium"
            >
              Tümünü okundu olarak işaretle
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationsPanel;